/**
 * Focus Mode visual gradient — fixed values per task index.
 * Index 0..4 step linearly; index 5+ stay at the same dimmest values.
 */
const FOCUS_OPACITY = [1.0, 0.85, 0.7, 0.55, 0.4];
const FOCUS_BLUR_PX = [0, 1, 2, 3, 4];

export function focusOpacity(index) {
  return FOCUS_OPACITY[index] ?? FOCUS_OPACITY[FOCUS_OPACITY.length - 1];
}

export function focusBlur(index) {
  return FOCUS_BLUR_PX[index] ?? FOCUS_BLUR_PX[FOCUS_BLUR_PX.length - 1];
}
